// SPDX-License-Identifier: AGPL-3.0-or-later

import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const GroupLeaveFailedModal = observer(() => {
	const {t} = useLingui();
	return (
		<GenericErrorModal
			title={t`Failed to Leave Group`}
			message={t`We couldn't remove you from the group at this time.`}
		/>
	);
});
